module.exports = __webpack_public_path__ + "static/img/5.eb187b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carouseImg/5.png
// module id = TaRO
// module chunks = 0